import './Workshop.css';
import HostWorkshop from './HostWorkshop';
import EnrollWorkshop from './EnrollWorkshop';
import homePageHeader from "../images/HomePage_header.png"; 


const WorkshopPage = () => {
  return (
    <div className="home-page">
      {/* Top "Lil' Chefs, Big World" Section */}
      <section 
        className="top-section" 
        style={{ backgroundImage: `url(${homePageHeader})` }}
      >
        <div className="top-overlay">
          <div className="top-content">
            <h2 className="workshops-label">WORKSHOPS</h2>
            <h1 className="main-title">Lil' Chefs, Big World</h1>
            <p className="description">
              Take our young chefs on a flavorful journey through their taste buds, 
              exploring diverse flavors and cultures right from your kitchen.
            </p>
            <div className="top-buttons">
              <a href="#host-section" className="btn host-btn">HOST A CLASS</a>
              <a href="#enroll-section" className="btn join-btn">JOIN CLASSES</a>
            </div>
          </div>
        </div>
      </section>

      {/* Host a Culinary Workshop Section */}
      <section id="host-section">
        <HostWorkshop />
      </section>

      {/* Enroll Section (REAL component) */}
      <section id="enroll-section">
        <EnrollWorkshop />
      </section>
    </div>
  );
};

export default WorkshopPage;
